export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Code',
    },
    cell: {
      type: 'text',
      value: (e) => e.codeShort,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Creator',
    },
    cell: {
      type: 'slot',
      name: 'creator',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Recipient',
    },
    cell: {
      type: 'slot',
      name: 'recipient',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Amount',
    },
    cell: {
      type: 'slot',
      name: 'amount',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'codeStatus',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Blocked',
    },
    cell: {
      type: 'slot',
      name: 'blocked',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Created',
    },
    cell: {
      type: 'slot',
      name: 'dateCreated',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Transaction Id',
    },
    cell: {
      type: 'slot',
      name: 'transactionId',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Transaction status',
    },
    cell: {
      type: 'slot',
      name: 'transactionStatus',
    },
  },
];
